import { type ContractModel, type EntityModel } from "@doitintl/cmp-models";
import { Box, Stack, Typography } from "@mui/material";

import DataCouplet from "../../../../Components/DataCouplet";
import { formatNumber } from "../../../../utils/common";
import { NotAvailable } from "../../../Assets/Tabs/components/typographics";
import { pointOfSaleMap } from "../../ContractForm/const";
import { StatusChip } from "../../ContractsList/StatusChip";
import { getContractStatus } from "../utils";

type Props = {
  entity: EntityModel;
  entitiesLoading: boolean;
  accountManagerName: string;
  contract: ContractModel;
  showAnnualizedValue?: boolean;
  showPointOfSale?: boolean;
};

export const GeneralSection = ({
  entity,
  entitiesLoading,
  accountManagerName,
  contract,
  showAnnualizedValue,
  showPointOfSale,
}: Props) => (
  <Box component="section" data-cy="general-section">
    <Typography variant="h3">General</Typography>
    <Stack component="dl" spacing={1}>
      {showPointOfSale && (
        <DataCouplet
          key={`point-of-sale`}
          field="Point of sale"
          value={pointOfSaleMap.find((x) => x.value === contract.pointOfSale)?.label ?? ""}
          divider={true}
        />
      )}
      <DataCouplet
        key="billing-profile"
        field="Billing profile"
        value={entity ? `${entity.priorityId} - ${entity.name}` : "Unassigned"}
        loading={entitiesLoading}
        divider={true}
      />
      <DataCouplet
        key="account-manager"
        field="Account manager"
        value={accountManagerName ?? NotAvailable}
        divider={true}
      />
      {showAnnualizedValue && (
        <DataCouplet
          key="annual-value"
          field="Annualized value"
          value={`$${formatNumber(contract.estimatedValue, 0)}`}
          infoTooltip="The estimated yearly contract value in USD"
          divider={true}
        />
      )}
      <DataCouplet key="status" field="Contract type" value={contract.type} divider={true} />
      <DataCouplet
        key="contract-status"
        field="Status"
        value={<StatusChip status={getContractStatus(contract) ?? ""} />}
        divider={true}
      />
    </Stack>
  </Box>
);

export default GeneralSection;
